import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LicensePeriodResponse, LicenseResponse } from 'src/app/shared';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LicenseService {

  constructor(
    private http: HttpClient,
  ) { }

  getLicense(): Observable<LicenseResponse[]> {
    return this.http.get<LicenseResponse[]>(`${environment.apiUrl}/license/`).pipe();
  }

  getLicensePeriod(): Observable<LicensePeriodResponse[]> {
    return this.http.get<LicensePeriodResponse[]>(`${environment.apiUrl}/license/periods`).pipe();
  }
}
